import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  "xmlns:xlink": "http://www.w3.org/1999/xlink",
  viewBox: "-4 0 28 24"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, [...(_cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      style: {"stroke":"none","fill-rule":"nonzero","fill":"rgb(0%,0%,0%)","fill-opacity":"1"},
      d: "M12 0C8.7 0 6 2.7 6 6v5H3v13h18V11h-3V6c0-3.3-2.7-6-6-6Zm0 2c2.219 0 4 1.781 4 4v5H8V6c0-2.219 1.781-4 4-4Zm0 0",
      id: "lock_closed_svg__surface312956844"
    }, null, -1)
  ]))]))
}
export default { render: render }